<template>
  <v-data-table
    :page="page"
    :pageCount="numberOfPages"
    :options.sync="options"
    :server-items-length="totalItems"
    :headers="headers"
    :items="items"
    :search="search"
    :loading="loading"
    loading-text="Đang tải dữ liệu... Vui lòng chờ"
    :items-per-page="perPage"
    :footer-props="{
      showFirstLastPage: true
    }"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Giải đáp kỹ thuật</v-toolbar-title>
        <v-spacer/>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Nhập từ khóa"
          single-line
          hide-details
          class="shrink"
          clearable
        />
        <Form 
          :showDialog="dialog" 
          :item="item" 
          :user="parseInt(userId)"
          :onlyView="onlyView"
          @confirmed="onConfirmed" 
          @cancelled="onCancelled"
        />
        <Reply 
          :showDialog="dialogReply" 
          :item="item" 
          :readOnly="userId ? true : false"
          @confirmed="onConfirmed" 
          @cancelled="onCancelled"
        />
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline">Bạn có chắc bạn muốn xóa mục này?</v-card-title>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="primary darken-1" text @click="closeDelete">Hủy bỏ</v-btn>
              <v-btn color="pink darken-1" text @click="deleteItemConfirm">Đồng ý</v-btn>
              <v-spacer/>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogRemind" max-width="500px">
          <v-card>
            <v-card-title class="headline">Bạn có chắc bạn muốn nhắc chuyên gia?</v-card-title>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="primary darken-1" text @click="closeRemind">Thôi</v-btn>
              <v-btn color="pink darken-1" text @click="remindConfirm">Gửi lời nhắc</v-btn>
              <v-spacer/>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.id`]="{ index }">
      {{ (perPage * (page-1)) +  (index+1) }}
    </template>
    <template v-slot:item.custom_updated_at="{ item }">
      <span v-if="item.status == 1">
        {{item.custom_updated_at}}
      </span>
      <span v-else>-</span>
    </template>
    <template v-slot:item.traloi="{ item }">
      <div style="white-space: nowrap;">
        <span v-if="item.visible == 0">
          <v-icon>
            mdi-eye-off-outline
          </v-icon>
          Đang ẩn
        </span>
        <span v-else-if="item.is_late">
          <v-icon color="red">
            mdi-timer-sand-complete
          </v-icon>
          Trễ hạn
        </span>
        <span v-else-if="item.status == 1">
          <v-icon color="primary">
            mdi-check
          </v-icon>
          Đã trả lời
        </span>
        <span v-else>
          <v-icon color="warning">
            mdi-timer-sand
          </v-icon>
          Đang chờ
        </span>
      </div>
    </template>
    <template 
      v-slot:item.actions="{ item }" 
    >
      <div style="white-space: nowrap;">
        <template v-if="$role('chuyen-gia')">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                text
                color="success" 
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  @click="reply(item)"
                >
                  mdi-message-reply-text
                </v-icon>
                Trả lời
              </v-btn>
            </template>
            <span>Giải đáp kỹ thuật</span>
          </v-tooltip>
        </template>
        <template v-else>
          <v-btn 
            color="primary" 
            text
            @click="view(item)"
          >
            <v-icon left>
              mdi-eye
            </v-icon>
            Xem
          </v-btn>
          <v-btn 
            color="warning" 
            text
            @click="remind(item)"
            :disabled="!item.is_late"
          >
            <v-icon left>
              mdi-bell-ring
            </v-icon>
            Nhắc
          </v-btn>
        </template>
      </div>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Tải lại
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>
  import Form from '@/views/admin/supports/Form';
  import Reply from '@/views/admin/supports/Reply';
  import { mapActions } from 'vuex';
  export default {
    components: {
      Form, Reply
    },
    props: {
      userId: {
        type: Number,
        default: 0
      }
    },
    data: () => ({
      loading: false,
      dialog: false,
      dialogReply: false,
      dialogDelete: false,
      dialogRemind: false,
      onlyView: false,
      search: '',
      headers: [
        { text: 'STT', value: 'id'},
        { text: 'Trạng thái', value: 'traloi', align: 'center', sortable: false },
        { text: 'Lĩnh vực', value: 'branch.name' },
        { text: 'Tiêu đề', value: 'tieude' },
        { text: 'Ngày hỏi', value: 'custom_created_at' },
        { text: 'Ngày trả lời', value: 'custom_updated_at' },
        { 
          align: 'right', 
          text: 'Thao tác', 
          value: 'actions', 
          sortable: false 
        },
      ],
      page: 1,
      totalItems: 0,
      numberOfPages: 0,
      perPage: 10,
      items: [],
      editedIndex: -1,
      item: {},
      options: {}
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'thêm mới' : 'cập nhật';
      },
    },
    watch: {
      options: {
        handler() {
          this.initialize();
        },
      },
      search(){
        this.initialize();
      }
    },
    mounted () {
      if(this.$route.params.show){
        this.showDialog();
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      initialize () {
        const app = this;
        app.loading = true;
        const { page, itemsPerPage, type } = app.options;
        let pageNumber = page;
        let user = null;
        if(app.userId){
          user = app.userId;
        }
        let request = {
          params: {
            size: itemsPerPage,
            page: pageNumber,
            type: type,
            user: user,
            keyword: app.search
          }
        };
        axios.get("api/v1/supports", request)
          .then(response => {
            app.items = response.data.data;
            app.totalItems = response.data.total;
            app.numberOfPages = response.data.to;
            app.page = response.data.current_page;
            app.perPage = response.data.per_page;
            app.loading = false;
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      showDialog(item=null){
        this.item = item||{};
        this.dialog = true;
      },
      onConfirmed(item) {
        this.dialog = false;
        this.dialogReply = false;
        this.initialize();
      },
      onCancelled () {
        this.dialog = false;
        this.dialogReply = false;
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialog = true;
      },
      reply(item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialogReply = true;
      },
      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialogDelete = true;
      },
      deleteItemConfirm () {
        const app = this;
        axios.delete(`api/v1/supports/${app.item.id}`)
          .then(function (resp) {
            app.items = app.items.filter(val => val.id !== app.item.id);
            app.closeDelete();
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      remind(item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialogRemind = true;
      },
      view(item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialog = true;
        this.onlyView = true;
      },
      remindConfirm(){
        const app = this;
        axios.post('api/v1/supports-remind', app.item)
          .then((response) => {
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      close () {
        this.dialog = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      closeDelete () {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      closeRemind(){
        this.dialogRemind = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      }
    }
  }
</script>